import React, {useState, useEffect} from 'react';

function LabelAndInput(props) {
  const {
    className,
    type: initialType,
    inputId,
    input_testid,
    label_testid,
    inputClassName
  } = props;

  // props captured seperately
  const newProps = {...props};
  const [type, setType] = useState(props.type);

  // Sync type state with props when it changes
  useEffect(() => {
    setType(props.type);
  }, [props.type]);

  // remove seperately captured props from newProps
  delete newProps.type;
  delete newProps.className;
  delete newProps.inputClassName;
  delete newProps.select;
  delete newProps.inputId;
  delete newProps.children;

  function switchBetweenPasswordAndText() {
    setType(prevType => {
      if (prevType === 'password') {
        return 'text';
      }
      return 'password';
    });
  }

  let input;
  if (type === 'select')
    input = (
      <select
        {...newProps}
        id={inputId && `input-${inputId}`}
        title={newProps.name && newProps.name}
        className={`mt-1 p-2 border border-gray-400 bg-white rounded-md w-full ${inputClassName}`}
      >
        {props.children}
      </select>
    );
  else if (type === 'radio')
    input = (
      <div {...newProps}>
        {props.radiooptions.map((option, index) => (
          <div key={index}>
            <input
              type='radio'
              id={`input-${option.label}`}
              name={newProps.name}
              className={`${inputClassName}`}
              value={option.value}
              data-testid={input_testid}
              checked={option.checked}
              onChange={newProps.onChange}
            />
            <label
              htmlFor={`input-${option.label}`}
              className='pl-2'
              data-testid={label_testid}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    );
  else
    input = (
      <React.Fragment>
        <input
          {...newProps}
          id={inputId && `input-${inputId}`}
          title={newProps.name && newProps.name}
          autoComplete={props.autoComplete ? 'on' : 'off'}
          type={type}
          className={`mt-1 p-2 border border-gray-400 bg-white rounded-md w-full ${inputClassName}`}
          data-testid={input_testid}
        />
        {initialType === 'password' && (
          <div onClick={switchBetweenPasswordAndText}>
            {type === 'password' ? (
              <i className='fa-sharp fa-solid fa-eye-slash -ml-8'></i>
            ) : (
              <i className='fa-solid fa-eye -ml-8'></i>
            )}
          </div>
        )}
      </React.Fragment>
    );

  return (
    <div className={`flex flex-col my-2 ${className}`}>
      <div className='font-bold'>
        {props.label}
        <span className='font-normal text-sm'> {props.description}</span>
      </div>
      <div className='flex items-baseline w-full'>{input}</div>
    </div>
  );
}

export default LabelAndInput;
